import Num from '@flipster/utils/num';

/**
 * 현재 활성 position bracket을 해석한다 (ERD-240 §10):
 * WS positionBracket id 우선(off-hours 실시간 스위칭), 없으면 specs instrument.positionBracket.
 * WS id는 `market/pswaps` 채널로 실시간 전달된다(백엔드 스펙) — 소비 측에서 그 값을 주입한다.
 * WS id가 로드된 brackets 맵에서 해석되지 않으면(스냅샷/배포 경계의 stale specs) specs id로 폴백해
 * bracket=undefined로 인한 주문 검증 전면 차단을 방지한다.
 *
 * `isOffHoursEnabled`(tradfi-offhours 플래그)가 false면 WS 실시간 스위칭을 무시하고 항상 specs
 * 기본 브래킷을 쓴다 — 플래그 off일 때 청산가/Max leverage/검증이 off-hours 브래킷으로 바뀌지 않게 한다.
 */
export const resolvePositionBracket = <B>(
  wsPositionBracketId: string | undefined | null,
  instrument: { positionBracket: string } | undefined | null,
  brackets: Record<string, B> | undefined | null,
  isOffHoursEnabled = true,
): B | undefined => {
  if (!instrument || !brackets) return undefined;
  const wsId = isOffHoursEnabled ? wsPositionBracketId : undefined;
  return (wsId != null ? brackets[wsId] : undefined) ?? brackets[instrument.positionBracket];
};

/**
 * pswap 데이터로부터 symbol 레벨의 bracket params를 계산한다.
 * (existingPositionSize, existingMargin, totalEffectiveLeverage)
 */
export function getSymbolLevelBracketParams(
  pswap: { totalEffectiveLeverage?: string; totalPotentialAmount?: string } | undefined | null,
) {
  const totalEffectiveLeverage = Num(pswap?.totalEffectiveLeverage || 0);
  const existingPositionSize = Num(pswap?.totalPotentialAmount || 0);
  const existingMargin = !totalEffectiveLeverage.isZero()
    ? existingPositionSize.dividedBy(totalEffectiveLeverage)
    : Num(0);

  return {
    totalEffectiveLeverage,
    existingPositionSize,
    existingMargin,
  };
}
